import { render, staticRenderFns } from "./ItemPassage.vue?vue&type=template&id=0de2cf16&scoped=true"
import script from "./ItemPassage.vue?vue&type=script&lang=js"
export * from "./ItemPassage.vue?vue&type=script&lang=js"
import style0 from "./ItemPassage.vue?vue&type=style&index=0&id=0de2cf16&prod&scoped=true&lang=css"
import style1 from "./ItemPassage.vue?vue&type=style&index=1&id=0de2cf16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de2cf16",
  null
  
)

export default component.exports